import React from "react";

function Button({ text, bgColor, textColor, customStyles, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        background: bgColor,
        color: textColor,
      }} // Apply dynamic background color here
      className={` leap-rounded-2xl leap-min-h-[56px] leap-font-semibold  leap-min-w-[217px] leap-text-xl ${customStyles}`}
    >
      {text}
    </button>
  );
}

export default Button;
